import { render, staticRenderFns } from "./AddEditFringeBenefits.vue?vue&type=template&id=c9456638&scoped=true"
import script from "./AddEditFringeBenefits.vue?vue&type=script&lang=js"
export * from "./AddEditFringeBenefits.vue?vue&type=script&lang=js"
import style0 from "./AddEditFringeBenefits.vue?vue&type=style&index=0&id=c9456638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9456638",
  null
  
)

export default component.exports